import React, {Component} from "react";

import DropzoneComponent from 'react-dropzone-component';

class ImageEditing extends Component{
    constructor(props) {
        super(props);
        this.state =  {
            file: '',
            isImageSet: false,
            isMultipleFile: false,
            ReactDOMServer:require('react-dom/server')
        }

        this.componentConfig = {
            iconFiletypes: ['.jpg', '.png', '.gif'],
            showFiletypeIcon: true,
            postUrl: "no-url",
        };

        this.dropzone = null;

        this.callback = (file) => {

            document.getElementsByClassName("dz-message")[0].style.display = "none";
        };

        this.removedFile = () => {
            document.getElementsByClassName("dz-message")[0].style.display = "block";
        };


    }


    render() {
        const config = this.componentConfig;
        let djsConfig = {
                maxFiles: 1,
                uploadMultiple:false,
                addRemoveLinks: true,
                thumbnailWidth: 210,
                thumbnailHeigth: 120,
                acceptedFiles: "application/pdf",
                autoProcessQueue: false,
                previewTemplate: this.state.ReactDOMServer.renderToStaticMarkup(
                    <div className="dz-preview dz-file-preview">
                        <div className="dz-details">
                            <div className="dz-filename"><span data-dz-name="true"></span></div>
                        </div>
                        <div className="dz-progress"><span className="dz-upload" data-dz-uploadprogress="true"></span></div>
                    </div>
                )
            }
        


        const eventHandlers = {

            addedfile: (file, isInitCall = false) =>{

                if(this.state.isImageSet === false){
                    this.callback(file);
                    this.setState({isImageSet:true});

                    if (isInitCall !== true){

                        this.props.setFile(file, "add");
                    }
                }
                else{
                    this.setState({isMultipleFile: true});
                    this.state.dropzone.removeFile(file);
                }
            },

            removedfile: (file) =>{

                if (this.state.isImageSet && this.state.isMultipleFile === false){

                    this.removedFile();
                    this.props.setFile(file, "delete");

                    this.setState({isImageSet:false});

                }
                else{
                    this.setState({isMultipleFile: false});
                }


            },


            init:(dropzone) => {

                this.setState({"dropzone":dropzone});

                if (this.props.file){

                    var mockFile = { name: this.props.file };

                    dropzone.emit("addedfile", mockFile, true);

                    dropzone.emit("complete", mockFile);
                }

            },


        }

        return(

            <DropzoneComponent
                config={config}
                eventHandlers={eventHandlers}
                djsConfig={djsConfig}
                >
                <div className="dz-message">

                        <p><i className="icon ion-ios-cloud-upload-outline"></i>Arrasta ou seleciona um ficheiro PDF.</p>

                </div>
            </DropzoneComponent>

        )
    }
}

export default ImageEditing;
